const fetchWithTimeout = (url: string, options: any, timeout: number = 15000) => {
  return Promise.race([fetch(url, options), new Promise((_, reject) => setTimeout(() => reject(new Error('Сервер хариу өгсөнгүй!')), timeout))])
}
export default fetchWithTimeout
